<template>
  <div>
    <van-nav-bar title="我的订单" right-text="创建" left-text="退出" @click-right="onClickNew" @click-left="onExit"/>
    <van-cell-group>
      <van-cell v-for="item in list" :key="item.id" :title="item.no" :value="'￥' + item.price"
      is-link :url="'#/vieworder?id='+item.id"
      >
        <template #label>
            <van-tag type="primary" style="padding:0 5px" plain >人数 {{item.peoples}}</van-tag>
            &nbsp;&nbsp;
            <van-tag type="primary" style="padding:0 5px" plain >天数 {{item.days}}</van-tag>
            &nbsp;&nbsp;
            <van-tag v-if="item.status==0" type="danger" style="padding:0 5px" plain >未支付,名单上传失败</van-tag>
            <van-tag v-else-if="item.status==1" type="primary" style="padding:0 5px" plain >已支付,名单上传成功</van-tag>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getdata } from '@/api/index.js'
import { utilsMixin } from '@/mixin/utils'
import { removeToken } from '@/utils/auth'
export default {
  name: 'Index',
  mixins: [utilsMixin],
  data() {
    return {
      list: [],
      totalRecord: 0,
      listLoading: false
    }
  },
  created() {
      this.fetch()
  },
  methods: {
    fetch() {
        getdata().then(response => {
            if (response.success && response.data != null) {
              this.list = response.data.data
              this.totalRecord = response.data.data.length
            }
            this.listLoading = false
          }).catch((e) => {
            Toast.fail(e)
            this.listLoading = false
          })
    },
    onClickNew() {
      this.$router.push({
          'path': '/createOrder'
      })
    },
    labelShow(item) {
        return "人数 " + item.peoples + " 天数 " + item.days
    },
    onExit() {
      removeToken()
      this.$router.push({
        path: 'login'
      })
    }
  }
}
</script>
